import React from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function () { return ({
    card: {
        borderRadius: "10px",
        boxShadow: "0px 15px 35px rgba(60, 66, 87, 0.12), 0px 5px 15px rgba(0, 0, 0, 0.12)",
        height: "568px",
        width: "100%",
    },
    contentCard: {
        marginLeft: "16px",
        marginRight: "16px",
        maxHeight: "453px",
        overflow: "auto",
        paddingTop: "35px",
    },
    letter: {
        color: "#6D7781",
        fontSize: "14px",
    },
    modal: {
        background: "#FFFFFF",
        borderRadius: "8px",
        boxShadow: "0px 7px 14px rgba(60, 66, 87, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.12)",
        left: "12px",
        position: "absolute",
        right: "12px",
        width: "auto",
    },
    textButton: {
        fontSize: "1rem !important",
        lineHeight: "22.4px",
        width: "250px",
        wordBreak: "break-word",
    },
}); });
var _capitalize = function (text) {
    return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
};
export var ConfrontaQuestion = function (props) {
    var classes = useStyles();
    return (React.createElement(Grid, { item: true, xs: 12, alignContent: "center" },
        React.createElement(Box, { display: "flex", justifyContent: "center", flexDirection: "column" },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { display: "flex", alignItems: "center", flexDirection: "column" },
                    React.createElement(Box, { py: 1, display: "flex", justifyContent: "center" },
                        React.createElement(Typography, { className: classes.letter },
                            _capitalize(props.question.text),
                            ":")))),
            React.createElement(Grid, { item: true, xs: 10 },
                React.createElement(Box, { display: "flex", paddingLeft: 5, paddingRight: 5, justifyContent: "flex-end" },
                    React.createElement(Typography, { className: classes.letter },
                        props.question.id,
                        " / ",
                        props.questionLength))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Box, { display: "flex", alignItems: "center", flexDirection: "column" }, props.question.options.map(function (answers, index) { return (React.createElement(Box, { py: 1, key: index, display: "flex", justifyContent: "center" },
                    React.createElement(Button, { onClick: function () {
                            return props.handleSelectAnswer({
                                answer: answers.id,
                                id: answers.text,
                            });
                        }, className: classes.textButton, variant: "outlined" }, _capitalize(answers.text)))); }))))));
};
